import React, { useState } from "react";
import "./ImageWithModal.css";

/**
 * Reusable image component with modal on hover
 * @param {string} src - Image source URL
 * @param {string} alt - Image alt text
 * @param {string} className - Additional CSS classes
 */
function ImageWithModal({ src, alt, className = "" }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className={`image-with-modal-wrapper ${className}`}>
      <img 
        src={src}
        alt={alt}
        className="image-with-modal-thumbnail"
        onMouseEnter={() => setShowModal(true)}
        onMouseLeave={() => setShowModal(false)}
      />
      {showModal && (
        <div className="image-with-modal-overlay">
          <div className="image-with-modal-content">
            <img 
              src={src}
              alt={alt}
              className="image-with-modal-large"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageWithModal;

